module.exports = __webpack_public_path__ + "img/12.a114ef6c.png";